import { useEffect, useState } from 'react';
import CustomGameButton from '../common/CustomGameButton';
import { LinearProgress } from '@mui/material';

const QuestionComponent = ({ isIdleOrEnded, currentQuestion, gameState, submitResponse, isClosed }) => {
  const [userAnswer, setUserAnswer] = useState(null);
  const [submittedAnswer, setSubmittedAnswer] = useState(false);
  const [isThereCorrectAnswer, setIsThereCorrectAnswer] = useState(true);

  useEffect(() => {
    setUserAnswer(null);
    setSubmittedAnswer(false);
    console.log(currentQuestion);
    if (currentQuestion) setIsThereCorrectAnswer(currentQuestion.answers.some((answer) => answer.isCorrect === true));
  }, [currentQuestion]);

  const handleClick = (answer) => {
    if (submittedAnswer) return;
    setUserAnswer(answer);
  };

  const handleSubmit = () => {
    if (userAnswer) {
      setSubmittedAnswer(true);
      submitResponse(userAnswer.id, currentQuestion.id);
    }
  };

  const renderAttendeePollingView = () => {
    return (
      <div className="polling-view-wrapper">
        {currentQuestion.answers.map((answer, index) => {
          const percentage = gameState.attendeePollingResults?.[answer.id] || 0;
          const selectedStyle = userAnswer && userAnswer.id === answer.id ? { color: '#30368c' } : { color: '#55A4D9' };
          return (
            <div key={index} className="polling-view-wrapper-item">
              <div className="polling-view-body">
                <h3 dangerouslySetInnerHTML={{ __html: answer.text }} style={selectedStyle} />
                <h3 style={selectedStyle}>{percentage}%</h3>
              </div>
              <LinearProgress variant="determinate" value={percentage} />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="game-wrapper">
      <h2
        style={{ marginBottom: 5, fontSize: '2.5vh', fontWeight: 'bold' }}
        dangerouslySetInnerHTML={{ __html: currentQuestion.text }}
      />
      {submittedAnswer && gameState.attendeePollingResults ? (
        renderAttendeePollingView()
      ) : (
        <div>
          {currentQuestion.answers.map((answer, index) => (
            <CustomGameButton
              key={index}
              text={answer.text}
              isCorrect={answer.isCorrect}
              isSelected={userAnswer && userAnswer.id === answer.id}
              submittedAnswer={submittedAnswer}
              isClosed={submittedAnswer}
              isThereCorrectAnswer={isThereCorrectAnswer}
              onClick={() => handleClick(answer)}
            />
          ))}
        </div>
      )}

      {!submittedAnswer && (
        <button onClick={handleSubmit} className="unbranded-button submit">
          Submit
        </button>
      )}
    </div>
  );
};

export default QuestionComponent;
